// Helpers puros del form de la fila virtual.

// Fecha local YYYY-MM-DD. OJO: no usar toISOString() — es UTC y en MX por la
// noche regresa el día siguiente.
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const isPastDateISO = (iso) =>
  typeof iso === 'string' && ISO_DATE_RE.test(iso) && iso < todayISO();

// Llave estable para multi-selección (un mismo horario puede repetirse con
// distinta profesional).
export const slotKey = (slot) =>
  `${slot.id}-${slot.professional?.id ?? ''}-${slot.date}-${slot.init}`;

// El slot más próximo (fecha, luego hora). Alimenta choosen_start_date.
export const earliestSlot = (slots) => {
  const valid = (slots || []).filter((s) => s && s.date && s.init);
  if (valid.length === 0) return null;
  return valid
    .slice()
    .sort((a, b) => (a.date === b.date ? a.init.localeCompare(b.init) : a.date.localeCompare(b.date)))[0];
};

// "Nombre completo" → {name, lastname} para el backend (res.partner exige ambos).
// Heurística MX: 2 palabras = nombre + apellido; 3 = nombre(s) + 1 apellido;
// 4+ = nombre(s) + 2 apellidos.
export const splitFullName = (full) => {
  const tokens = String(full || '').trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return { name: '', lastname: '' };
  if (tokens.length === 1) return { name: tokens[0], lastname: '' };
  if (tokens.length === 2) return { name: tokens[0], lastname: tokens[1] };
  if (tokens.length === 3) return { name: tokens.slice(0, 2).join(' '), lastname: tokens[2] };
  return { name: tokens.slice(0, -2).join(' '), lastname: tokens.slice(-2).join(' ') };
};

// Máscara dd/mm/aaaa: solo dígitos, autoinserta diagonales (tecleo directo,
// sin navegar el date picker años atrás).
export const maskBirthDate = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

// "dd/mm/aaaa" → "aaaa-mm-dd" solo si es una fecha real, no futura y >= 1900.
export const birthMaskToISO = (masked) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(masked || '');
  if (!m) return null;
  const [, dd, mm, yyyy] = m;
  const d = Number(dd);
  const mo = Number(mm);
  const y = Number(yyyy);
  if (y < 1900) return null;
  const date = new Date(y, mo - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null;
  const iso = `${yyyy}-${mm}-${dd}`;
  return iso > todayISO() ? null : iso;
};

// N días consecutivos (ISO local) empezando hoy. Alimenta los chips de
// "qué día te gustaría" de la fila virtual.
export const upcomingDatesISO = (count) => {
  const out = [];
  const d = new Date();
  for (let i = 0; i < count; i += 1) {
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
    d.setDate(d.getDate() + 1);
  }
  return out;
};

// Shape que espera el backend (interested_slots en el DTO).
export const toInterestedPayload = (slots) =>
  (slots || []).map((s) => ({
    id: s.id,
    date: s.date,
    init: s.init,
    end: s.end,
    specialty_id: s.specialty?.id,
    professional_id: s.professional?.id,
  }));

// ─── Asociación / código (dropdown del registro) ───

// Valores sentinela del select (no chocan con ids numéricos de Odoo).
export const ASSOC_OTHER = '__other__';
export const ASSOC_NONE = '__none__';

// Mapea la selección de asociación al payload del lead. El dropdown
// atribuye (association_id) y el código verifica (association_code);
// ninguno bloquea: "otra organización", "por mi cuenta" o catálogo
// caído degradan a solo utm_term, como el texto libre de siempre.
export const buildAssociationPayload = (
  { asociacionSel, asociacionOtra, codigoAsociacion, sinCodigo },
  associations,
) => {
  const selected = (associations || []).find((a) => String(a.id) === String(asociacionSel)) || null;
  if (selected) {
    const code = sinCodigo ? '' : (codigoAsociacion || '').trim();
    return {
      utm_term: selected.name,
      association_id: selected.id,
      association_code: code || null,
    };
  }
  if (asociacionSel === ASSOC_NONE) {
    return { utm_term: 'Por mi cuenta', association_id: null, association_code: null };
  }
  return {
    utm_term: (asociacionOtra || '').trim(),
    association_id: null,
    association_code: null,
  };
};
